import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PaymentList from '../components/PaymentList';
import { Form, Button, Alert } from 'react-bootstrap';

const Payments = () => {
  const [payments, setPayments] = useState([]);
  const [formData, setFormData] = useState({ client: '', amount: 0, dueDate: '', status: 'pending' });
  const [error, setError] = useState('');

  const fetchPayments = async () => {
    try {
      const response = await axios.get('https://venticrm.unsoloclic.mx/api/payments');
      setPayments(response.data);
    } catch (err) {
      setError('Error obteniendo pagos');
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.client || !formData.amount || !formData.dueDate) {
      setError('Todos los campos son obligatorios');
      return;
    }
    try {
      await axios.post('http://localhost:5000/api/payments', formData);
      fetchPayments();
      setFormData({ client: '', amount: 0, dueDate: '', status: 'pending' });
      setError('');
    } catch (err) {
      setError('Error registrando pago');
    }
  };

  return (
    <div className="container mt-4">
      <h1>Pagos</h1>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Label>Cliente</Form.Label>
          <Form.Control
            type="text"
            value={formData.client}
            onChange={(e) => setFormData({ ...formData, client: e.target.value })}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Monto</Form.Label>
          <Form.Control
            type="number"
            value={formData.amount}
            onChange={(e) => setFormData({ ...formData, amount: parseFloat(e.target.value) })}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Fecha de Vencimiento</Form.Label>
          <Form.Control
            type="date"
            value={formData.dueDate}
            onChange={(e) => setFormData({ ...formData, dueDate: e.target.value })}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Estado</Form.Label>
          <Form.Control
            as="select"
            value={formData.status}
            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
          >
            <option value="pending">Pendiente</option>
            <option value="paid">Pagado</option>
            <option value="overdue">Atrasado</option>
          </Form.Control>
        </Form.Group>
        <Button type="submit" className="mt-3">Registrar Pago</Button>
      </Form>
      <PaymentList payments={payments} fetchPayments={fetchPayments} />
    </div>
  );
};

export default Payments;